import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Input,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeCreateLectureModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllChaptersRequest } from "../../../../modules/superadmin-modules/chapters/Actions";
import { getAllCoursesRequest } from "../../../../modules/superadmin-modules/courses/Actions";
import { getAllGroupsRequest } from "../../../../modules/superadmin-modules/groups/Actions";
import {
  createPdfRequest,
  editPdfRequest,
} from "../../../../modules/superadmin-modules/lectures/Actions";
const AddPDF = ({ isAdd, data, setSelectedData }) => {
  const [selected, setSelected] = useState("");

  const openLecture = useSelector((state) => state.model.isOpen12);
  const chapters = useSelector((state) => state.superadminChapters.chapters);
  const courses = useSelector((state) => state.courses.courses);
  const { groups } = useSelector((state) => state.superadminGroups);

  const isLoading = useSelector((state) => state.superadminPdfs.isLoading);

  const chaptersOptions = chapters?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const coursesOptions = courses?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const dispatch = useDispatch();
  useEffect(() => {
    if (openLecture) {
      dispatch(getAllChaptersRequest());
      dispatch(getAllGroupsRequest());
      dispatch(getAllCoursesRequest());
    }
  }, [openLecture]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    defaultValues: data ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة PDF" : "تعديل  PDF"}
      </Heading>
    </Box>
  );
  const onSubmit = async (values) => {
    let formData = await new FormData();
    for (let key in values) {
      if (key == "student_group_ids") {
        values?.student_group_ids?.map((val, index) => {
          formData.append(`student_group_ids[${index}]`, values[key]?.[index]);
        });
      } else formData.append(key, values[key]);
    }
    const action = () => {
      dispatch(closeCreateLectureModel());
      setSelectedData({});
      reset();
    };
    if (isAdd) {
      await dispatch(createPdfRequest(formData, action));
    } else {
      formData.append("_method", "PUT");

      dispatch(
        editPdfRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateLectureModel());
    setSelectedData({});
    reset();
  };

  console.log(isLoading);
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openLecture}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="اسم المحتوي"
              defaultValues={data.title}
              error={errors?.title?.message}
              placeholder="ادخل اسم المحتوي"
              register={register}
              name="title"
            />
          </Box>

          <Box w="45%">
            <FormLabel>وصف المحتوي : </FormLabel>

            <Textarea
              defaultValues={data.description}
              error={errors?.description?.message}
              placeholder="وصف المحتوي"
              register={register}
              name="description"
              bg="#f5f5f5"
            />
          </Box>

          <Box w="45%">
            <Box w="100%">
              <FormLabel>الفصول : </FormLabel>
              <Select
                options={chaptersOptions}
                onChange={(data) => setValue("chapter_id", data.value)}
                styles={colourStyles}
                placeholder="الصف"
                defaultValue={{
                  label: data?.chapter?.name,
                  value: data?.chapter?.id,
                }}
              />
            </Box>
          </Box>

          <Box w="45%">
            <Box w="100%">
              <FormLabel>السنة الدراسية : </FormLabel>
              <Select
                options={coursesOptions}
                onChange={(data) => setValue("course_id", data.value)}
                styles={colourStyles}
                placeholder="السنة الدراسية"
                defaultValue={{
                  label: data?.course?.name,
                  value: data?.course?.id,
                }}
              />
            </Box>
          </Box>
          <Box w="45%">
            <FormLabel> المجموعات : </FormLabel>

            <Select
              options={groupsOptions}
              isMulti
              onChange={(data) => {
                data?.map((val, index) => {
                  setValue(`student_group_ids[${index}]`, val?.value);
                });
              }}
              styles={colourStyles}
              placeholder="مجموعات"
              defaultValue={data?.student_groups?.map((val) => {
                return { label: val?.name, value: val?.id };
              })}
            />
          </Box>
          <Box w="45%">
            <FormLabel>رفع PDF:</FormLabel>
            <Button
              bg="main_1"
              color="white"
              borderRadius="8px"
              textAlign="center"
              position="relative"
              w="100%"
            >
              <Text>{selected ? selected : "اختر ملف ليتم رفعه"} </Text>
              <Input
                onChange={(e) => {
                  setValue("file", e.target.files[0]);
                  setSelected((s) => e.target.files[0].name);
                }}
                type="file"
                placeholder="اختر ملف ليتم رفعه"
                opacity="0"
                position="absolute"
                w="100%"
                h="100%"
              />
            </Button>
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddPDF;
